import React from "react";
import { useT } from "../i18n";

export default function Footer() {
  const t = useT();
  return (
    <footer className="border-t border-gray-100 mt-auto py-3 px-4 text-center text-xs text-gray-400 space-y-0.5">
      <p>
        <a href="/about/" className="hover:text-brand-600 hover:underline transition-colors">{t("footer.about")}</a>
        <span className="mx-1.5 select-none">|</span>
        <a href="/privacy/" className="hover:text-brand-600 hover:underline transition-colors">{t("footer.privacy")}</a>
        <span className="mx-1.5 select-none">|</span>
        <a href="/terms/" className="hover:text-brand-600 hover:underline transition-colors">{t("footer.terms")}</a>
      </p>
      <p>&copy; 2024&ndash;2026 MeW Project / The University of Osaka</p>
    </footer>
  );
}
